import styled from "styled-components";
import { PartnersWrap } from "../../../Partners/style";

export const PartnersWrapTeamPage = styled(PartnersWrap)`
  padding: 7% 0 15% 0;
  @media only screen and (max-width: 768px) {
    padding-bottom: 10rem;
  }
`;
